import { useState, useEffect } from 'react';

/**
 * Hook personalizzato per monitorare lo stato della connessione di rete.
 *
 * @param {boolean} checkInternet - Se true, esegue un test di fetch per verificare l'effettivo accesso a Internet.
 */
function useNetworkStatus(checkInternet = false) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isInternetAvailable, setIsInternetAvailable] = useState(true);

  const checkInternetAccess = async () => {
    try {
      // Utilizzo di mode: "no-cors" per evitare blocchi CORS su test di raggiungibilità
      await fetch('https://www.google.com', { mode: 'no-cors' });
      setIsInternetAvailable(true);
    } catch {
      setIsInternetAvailable(false);
    }
  };

  useEffect(() => {
    const updateNetworkStatus = () => {
      setIsOnline(navigator.onLine);

      if (checkInternet && navigator.onLine) {
        checkInternetAccess();
      } else if (!navigator.onLine) {
        setIsInternetAvailable(false);
      }
    };

    window.addEventListener('online', updateNetworkStatus);
    window.addEventListener('offline', updateNetworkStatus);

    updateNetworkStatus();

    return () => {
      window.removeEventListener('online', updateNetworkStatus);
      window.removeEventListener('offline', updateNetworkStatus);
    };
  }, [checkInternet]);

  return { isOnline, isInternetAvailable };
}

export default useNetworkStatus;
